/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_Activity_QueriedInputs */

const en_landing_preview_activity_queried = /** @type {(inputs: Landing_Preview_Activity_QueriedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`queried Energy coverage`)
};

/**
* | output |
* | --- |
* | "queried Energy coverage" |
*
* @param {Landing_Preview_Activity_QueriedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_activity_queried = /** @type {((inputs?: Landing_Preview_Activity_QueriedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_Activity_QueriedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_activity_queried(inputs)
});